var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83366 12.696L13.7087 6.82096L12.542 5.6543L7.83366 10.3626L5.45866 7.98763L4.29199 9.1543L7.83366 12.696ZM9.00033 17.196C7.84755 17.196 6.76421 16.9772 5.75033 16.5397C4.73644 16.1022 3.85449 15.5085 3.10449 14.7585C2.35449 14.0085 1.76074 13.1265 1.32324 12.1126C0.885742 11.0987 0.666992 10.0154 0.666992 8.86263C0.666992 7.70985 0.885742 6.62652 1.32324 5.61263C1.76074 4.59874 2.35449 3.7168 3.10449 2.9668C3.85449 2.2168 4.73644 1.62305 5.75033 1.18555C6.76421 0.748047 7.84755 0.529297 9.00033 0.529297C10.1531 0.529297 11.2364 0.748047 12.2503 1.18555C13.2642 1.62305 14.1462 2.2168 14.8962 2.9668C15.6462 3.7168 16.2399 4.59874 16.6774 5.61263C17.1149 6.62652 17.3337 7.70985 17.3337 8.86263C17.3337 10.0154 17.1149 11.0987 16.6774 12.1126C16.2399 13.1265 15.6462 14.0085 14.8962 14.7585C14.1462 15.5085 13.2642 16.1022 12.2503 16.5397C11.2364 16.9772 10.1531 17.196 9.00033 17.196Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.64a456479b17863b66016ae841b1d8a7.svg";
export { ForwardRef as ReactComponent };